import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";

export default function Specialties() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");

  const load = async () => { const { data } = await api.get("/specialties"); setItems(data); };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try { await api.post("/specialties", { name }); setName(""); load(); toast.success("Added"); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const del = async (id) => { try { await api.delete(`/specialties/${id}`); load(); } catch (e) { toast.error(formatApiError(e)); } };

  return (
    <div className="space-y-6 max-w-2xl">
      <h1 className="text-3xl font-bold text-slate-900">Specialties</h1>
      <form onSubmit={add} className="doccare-card p-4 flex gap-2">
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="New specialty…" className="rounded-xl h-11" data-testid="spec-name" />
        <Button type="submit" className="rounded-xl h-11" data-testid="spec-add"><Plus className="w-4 h-4 mr-1" /> Add</Button>
      </form>
      <div className="doccare-card divide-y divide-slate-100">
        {items.map((s) => (
          <div key={s.id} className="flex items-center justify-between p-3">
            <span className="font-medium">{s.name}</span>
            <button onClick={() => del(s.id)} className="text-red-500 hover:text-red-700" data-testid={`del-spec-${s.id}`}><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
        {items.length === 0 && <p className="p-6 text-sm text-slate-500 text-center">No specialties yet.</p>}
      </div>
    </div>
  );
}
